<template>
    <el-dialog
        class="preview-article-dialog"
        :visible.sync="visible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        fullscreen
    >
        <div class="preview">
            <div class="preview-title">{{ title }}</div>
            <div class="preview-content" v-if="pictureList && pictureList.length > 0">
                <img v-for="(picture, index) in pictureList" :src="picture.address" :key="index">
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { getUserZuoPinDetail } from "@/api/works";

export default {
    name: 'PreviewArticle',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, null],
            default: null
        }
    },
    data: () => ({
        title: '',
        pictureList: []
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    mounted() {
        if (!this.id) return;
        getUserZuoPinDetail({ zId: this.id, userId: this.userInfo.id }).then(({ code, data }) => {
            if (code === 0) {
                this.title = data.title;
                this.pictureList = data.pictureList;
            }
        });
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        }
    }
};
</script>

<style lang="scss">
.preview-article-dialog {
    .el-dialog__body {
        color: #000;
        font-size: 16px;
    }
}
</style>

<style lang="scss" scoped>
.preview-article-dialog {
    .preview {
        margin: 0 auto;
        width: 1276px;
        min-height: calc(100vh - 160px);
        &-title {
            color: #272c40;
            font-size: 22px;
            font-weight: 600;
            padding-bottom: 10px;
            border-bottom: 1px solid #ecedff;
        }
        &-content {
            padding: 20px 10px;
            overflow: auto;

            img {
                display: block;
                margin: 0 auto 10px;
                width: 850px;
            }
        }
    }
}
</style>
